<app-i18n-dictionary>
    <span [attr.transid]="emailPlaceholderTextId" i18n="@@email-placeholder">Email</span>
    <span [attr.transid]="passwordPlaceholderTextId" i18n="@@password-placeholder">Password</span>
</app-i18n-dictionary>

<form fxLayout="column" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field>
        <input appIosAutoFillFix type="email" matInput
               [placeholder]="i18nDictionary.get(emailPlaceholderTextId)"
               formControlName="email" required/>
        <mat-error *ngIf="emailControl.hasError('required')"
                   i18n="@@email-error-required">You must enter a value
        </mat-error>
        <mat-error *ngIf="emailControl.hasError('email')"
                   i18n="@@email-error-email">Not a valid email
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <input appIosAutoFillFix type="password" matInput
               [placeholder]="i18nDictionary.get(passwordPlaceholderTextId)"
               formControlName="password" [minlength]="minPasswordLength"/>
        <mat-error *ngIf="passwordControl.hasError('required')"
                   i18n="@@password-error-required">Password is required
        </mat-error>
        <mat-error *ngIf="passwordControl.hasError('minlength')"
                   i18n="@@password-error-minlength">Minimum length {{minPasswordLength}}
        </mat-error>
    </mat-form-field>

    <a class="password-reset-link" [class.disabled]="isPending" routerLink="/password-reset"
       i18n="@@login-form_reset-password">Forgot password?</a>

    <div class="actions" fxLayout="row" fxLayoutAlign="center center">
        <button class="btn-primary" [disabled]="isPending" i18n="@@login-form_submit-button">Login</button>
        <mat-spinner [diameter]="25" *ngIf="isPending"></mat-spinner>
    </div>
</form>

<div class="actions" fxLayout="row" fxLayoutAlign="center center">
    <button class="btn-primary" [disabled]="isPending" i18n="@@login-form_register-button"
            routerLink="/register">Request Account
    </button>
</div>

<p *ngIf="authError && !authError.isGlobalMessage" class="loginError">
    {{ authError.errorMessage }} [{{ authError.errorCodeFormatted }}]
</p>

<app-contact-box></app-contact-box>
